export const BI_ENDPOINT = 'platform';
export const BI_CM_ENDPOINT = 'platform-cm';
export const BI_SANTA_EDITOR_ENDPOINT = 'editor';
export const BI_VIEWER_ENDPOINT = 'platform-viewer';
export const BI_ERROR_ENDPOINT = 'trg';
export const BI_SOURCE = 79;
export const BI_CM_SOURCE = 83;
export const BI_SANTA_EDITOR_SOURCE = 38;
export const BI_CM_EDITOR_ENV = 'EDITOR';
export const BI_CM_BUSINESS_MANAGER_ENV = 'BUSINESS_MANAGER';
//# sourceMappingURL=constants.js.map